/* eslint-disable no-trailing-spaces */

import Detail from './gastro/Detail';
import Checkout from './gastro/Checkout'
import Thanks from './gastro/Thanks'
import History from './gastro/History'
import TrackOrder from './gastro/TrackOrder'
import './gastro/App.css';
import './gastro/gastro.scss'

/* eslint-disable no-unused-vars */
import { BusinessProvider } from './providers/BusinessContext';
import { ConfigProvider } from "./providers/ConfigContext";
import { CartProvider } from './providers/CartContext';
import { UserProvider } from './providers/UserContext';
import { ChatProvider } from '@/apps/components/chat';
import { ChatBubble } from '@/apps/components/chat';
import { getFromApi } from '../lib/js/api'

const App = (props) => {

  const [stage, setStage] = React.useState("detail")
  const [checkoutData, setCheckoutData] = React.useState(null)

  const getServicesContent = () => {
    console.log("get services content", stage, window.menu)

    if (stage == "detail") {
      return <Detail business={window.business} menu={window.menu} setStage={setStage} />
    } else if (stage == "checkout") {
      return <Checkout business={window.business} menu={window.menu} doCheckout={(data) => {
        setCheckoutData(data)
        setStage("thanks")
      }} />
    } else if (stage == "thanks") {
      return <Thanks business={window.business} menu={window.menu}
        setStage={setStage} checkoutData={checkoutData} />
    } else if (stage == "history") {
      return <History business={window.business} menu={window.menu}
        setStage={setStage} showThanks={(data) => {
          setCheckoutData(data)
          setStage("thanks")
        }} />
    }

    return <></>
  }

  const getContent = () => {

    if (window.gastroStage && window.gastroStage == "track") {
      return <TrackOrder business={window.business} menu={window.menu}
        setStage={setStage} />
    }
    //console.log("get content", stage)

    let business = window.business

    if (business.type == "Services") {
      return getServicesContent()
    }

    if (stage == "detail") {
      return <Detail business={window.business} menu={window.menu} local={window.local} setStage={setStage} />
    } else if (stage == "checkout") {
      return <Checkout business={window.business} menu={window.menu} local={window.local} setStage={setStage}
        doCheckout={(data) => {
          setCheckoutData(data)
          setStage("thanks")
        }} />
    } else if (stage == "thanks") {
      return <Thanks business={window.business} menu={window.menu}
        setStage={setStage} checkoutData={checkoutData} />
    } else if (stage == "track") {
      return <TrackOrder business={window.business} menu={window.menu}
        setStage={setStage} />
    } else if (stage == "history") {
      return <History business={window.business} menu={window.menu}
        setStage={setStage} showThanks={(data) => {
          setCheckoutData(data)
          setStage("thanks")
        }} />
    }

    return <></>
  }

  return (

    <BusinessProvider>
      <CartProvider>
        <UserProvider>
          <ChatProvider>
            <ConfigProvider>
              <div style={{ marginBottom: 50, width: '99%', height: '99%' }}>
                {getContent()}

                <div className="row  powered-row">
                  <div className="col centered" ><span>Powered By</span></div>
                </div>

                <div className=" logo-row" >
                  <a href="https://zono.cc" target="blank">
                    <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
                  </a>
                  {window.business.hasChat &&
                  
                  <ChatBubble />
                  }
                </div>

              </div>

            </ConfigProvider>
          </ChatProvider>
        </UserProvider>
      </CartProvider>
    </BusinessProvider>
  );
}

document.addEventListener('DOMContentLoaded', function () {


  const container = document.getElementById('menu-view');

  if (container) {
    const root = ReactDOM.createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<App />);
  }
})
